// Helpers de máscara/limpeza de CNPJ no formato alfanumérico
// (vigente a partir do 2º semestre de 2026).
// A validação é feita pela lib `validations-br` (>= 1.7.0), que já suporta
// o formato alfanumérico. Aqui ficam apenas a máscara de input, a limpeza
// para envio à API e a formatação de exibição.

// Máscara de input para uso com vue-the-mask.
// 'N' = alfanumérico com uppercase (token custom, ver plugins/VueTheMask.js),
// '#' = numérico (dígitos verificadores).
export const CNPJ_MASK = 'NN.NNN.NNN/NNNN-##'

// Remove máscara e normaliza: mantém apenas [0-9A-Z] em maiúsculo (14 posições).
export function limparCNPJ (value) {
  return (value || '').toString().toUpperCase().replace(/[^0-9A-Z]/g, '')
}

// Aplica a máscara visual XX.XXX.XXX/XXXX-XX. Retorna o valor limpo se não tiver 14 posições.
export function maskCNPJ (value) {
  const cnpj = limparCNPJ(value)
  return cnpj.replace(
    /^([0-9A-Z]{2})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{4})(\d{2})$/,
    '$1.$2.$3/$4-$5'
  )
}
